import { Component, Input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { UserPaymentIntent } from '../../../models/shopping';
import { Price } from '../../common/price/price';
import { CheckoutListItem } from '../checkout-list-item/checkout-list-item';

@Component({
  selector: 'app-checkout-summary',
  imports: [CheckoutListItem, MatDividerModule, Price],
  templateUrl: './checkout-summary.html',
  styleUrl: './checkout-summary.scss',
})
export class CheckoutSummary {
  @Input({ required: true }) user_payment_intent!: UserPaymentIntent;
}
